<template>
  <div>
    <base-header class="pb-6" id="color_custom" style="background-color: #248dc1 !important;">
      <div class="row align-items-center py-4">
        <div class="col-lg-12 col-12">
          <h6 class="h2 text-white d-inline-block mb-0">{{$store.state.user.sponsor_branch}}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <!--
        <div class="col-lg-6 col-5 text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </div>
        -->
      </div>
      <!-- Card stats -->
      <!--
      <div class="row">
        <div class="col-xl-3 col-md-6">
          <stats-card title="Total traffic"
                      type="gradient-red"
                      sub-title="350,897"
                      icon="ni ni-active-40">

            <template slot="footer">
              <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card title="Total traffic"
                      type="gradient-orange"
                      sub-title="2,356"
                      icon="ni ni-chart-pie-35">

            <template slot="footer">
              <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card title="Sales"
                      type="gradient-green"
                      sub-title="924"
                      icon="ni ni-money-coins">

            <template slot="footer">
              <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>

        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card title="Performance"
                      type="gradient-info"
                      sub-title="49,65%"
                      icon="ni ni-chart-bar-32">

            <template slot="footer">
              <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </div>
      </div>
      -->
    </base-header>

    <!--Formulario-->
    <div class="container-fluid mt--6">
      <div class="row">
        

        <div class="col-xl-12">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Venta de Planes</h6>
                <h5 class="h3 mb-0">Ingreso de nueva venta</h5>
              </div>
              <div class="col">
                <ul class="nav nav-pills justify-content-end">
                  <li class="nav-item mr-2 mr-md-0">
                    <base-button icon type="primary" :disabled="step === 1" @click="$refs.stepper.previous()">
                        <span class="btn-inner--icon"><i class="ni ni-bold-left"></i></span>
                        <span class="btn-inner--text">Anterior</span>
                    </base-button>
                  </li>
                  <!--
                  <li class="nav-item">
                    <base-button :disabled="step === steps" icon type="primary" @click="$refs.stepper.next()">
                        <span class="btn-inner--text">Siguiente</span>
                        <span class="btn-inner--icon"><i class="ni ni-bold-right"></i></span>
                    </base-button>
                  </li>
                  -->
                </ul>
              </div>
            </div>
            <v-stepper ref="stepper" :steps="steps" v-model="step"></v-stepper>
            <br>
                <section v-if="step === 1">
                  <form class="needs-validation" id="formSelectCategories"
                          @submit.prevent="sendForm">
                      
                      <div class="form-row">
                          <div class="col-md-12">
                            <base-input label="Seleccione categoria del plan:">
                                <el-select @change="updateSubCategorias" v-model="categoria.value" filterable
                                            placeholder="Categoria del Plan">
                                    <el-option v-for="option in selectCategorias"
                                                :key="option.label"
                                                :label="option.label"
                                                :value="option.value">
                                    </el-option>
                                </el-select>
                            </base-input>
                          </div>
                      </div>
                      <div class="form-row" v-if="categoria.value != undefined">
                          <div class="col-md-12">
                            <base-input label="Seleccione sub-categoria:">
                                <el-select  v-model="subCategoria.value" filterable
                                            placeholder="Sub-categoria del Plan"
                                            @change="fetchDataAttrs"
                                            >
                                    <el-option v-for="option in selectSubCategorias"
                                                :key="option.label"
                                                :label="option.label"
                                                :value="option.value">
                                    </el-option>
                                </el-select>
                            </base-input>
                          </div>
                      </div>
                      <!--
                      <div class="form-row" v-if="subCategoria.value != undefined">
                          <div class="col-md-12">
                            <base-input label="Ingrese monto de venta:">
                                <vue-numeric class="form-control" currencySeleccione="$" separator="." v-model="monto_venta"></vue-numeric>
                            </base-input>
                          </div>
                      </div>
                      -->
                      <div class="form-row" v-for="(item,index) in attrs" :key="index" >
                        <div class="col-md-12" v-if="item.tipo_campo == 'ENUM'">
                          <base-input :label="'Seleccione: '+item.nombre_publico || item.nombre_identificatorio"
                            :name="(item.nombre_publico || item.nombre_identificatorio)"
                            :error="getError((item.nombre_publico || item.nombre_identificatorio))"
                            v-validate="'required'"
                            v-model="attrFields[index]"
                          >
                              <el-select  v-model="attrFields[index]" filterable
                                          placeholder="Selecciona una opción..."
                                          >
                                  <el-option v-for="option in item.opciones"
                                              :key="option"
                                              :label="option"
                                              :value="option">
                                  </el-option>
                              </el-select>
                          </base-input>
                        </div>
                        <div class="col-md-12" v-if="item.tipo_campo == 'RANGE'">
                          <base-input type="number" v-model="attrFields[index]" :label="'Ingrese '+(item.nombre_publico || item.nombre_identificatorio)+':'"
                            :name="(item.nombre_publico || item.nombre_identificatorio)"
                            :error="getError((item.nombre_publico || item.nombre_identificatorio))"
                            v-validate="'required'"
                            step="0.001"
                          >

                          </base-input>
                        </div>
                        <div class="col-md-12" v-if="item.tipo_campo == 'VARIABLE'">
                          <base-input type="number" v-model="attrFields[index]" :label="'Ingrese '+(item.nombre_publico || item.nombre_identificatorio)+':'"
                            :name="(item.nombre_publico || item.nombre_identificatorio)"
                            :error="getError((item.nombre_publico || item.nombre_identificatorio))"
                            v-validate="'required'"
                          >

                          </base-input>
                        </div>
                      </div>
                      <div class="form-row">
                          <base-button :disabled="!firstStepReady || cargando" icon type="primary" @click="finishStepOne">
                              <span class="btn-inner--text">Buscar</span>
                              <span class="btn-inner--icon"><i class="ni ni-bold-right"></i></span>
                          </base-button>
                      </div>

                  </form>
                </section>
                <!-- STEP 2 -->
                <section v-if="step === 2">
                  <h4> Planes disponibles: </h4> <br>
                  <isotope ref="isotope" :options="opcionesIsotope" :list="lista_planes"  >
                    <div v-for="element in lista_planes" :key="element.id">
                      <!--
                      <card type="frame">
                        {{element.name}}
                      </card>
                      -->
                      <stats-card class="bg-gradient-primary" style="margin: 10px 10px;min-width: 270px;">
                          <!-- Card body -->
                          <div class="row">
                              <div class="col">
                                  <h5 class="card-title text-uppercase text-muted mb-0 text-white">{{element.company.name}}</h5>
                                  <span class="h2 font-weight-bold mb-0 text-white">{{element.name}}</span>
                              </div>
                              <div class="col-auto">
                                  <!--
                                  <div class="icon icon-shape bg-white text-dark rounded-circle shadow">
                                      <i class="ni ni-active-40"></i>
                                  </div>
                                  -->
                                  <base-button round class="btn-slack btn-icon-only" @click="toThirdStep(element)">
                                    <span class="btn-inner--icon"><i class="ni ni-bold-right"></i></span>
                                  </base-button>
                              </div>
                          </div>
                          <p class="mt-3 mb-0 text-sm">
                              <span class="text-white mr-2"><i class="ni ni-money-coins"></i><b> $ {{ element.valor  }} </b></span>
                              <span class="text-nowrap text-light">Valor del seguro</span>
                          </p>
                          <p class="mt-3 mb-0 text-sm">
                              <a @click="mostrarDetalles(element)" ><span class="text-white mr-2"><i class="ni ni-zoom-split-in"></i> Ver detalles</span></a>
                          </p>
                      </stats-card>
                    </div>
                  </isotope>
                  <form>
                    <div class="form-row" v-show="lista_planes.length > 1">
                        <div class="col-md-3">
                          <base-input label="Ordenar por:">
                              <el-select @change="updateOrderFilter" v-model="filtroOrdenar" filterable
                                          placeholder="Ordenar Planes">
                                  <el-option v-for="option in selectFiltroOrdenar"
                                              :key="option.label"
                                              :label="option.label"
                                              :value="option.value">
                                  </el-option>
                              </el-select>
                          </base-input>
                        </div>
                    </div>
                  </form>
                </section>
                <!--
                <stats-card title="Total traffic" v-if="step === 2"
                            type="gradient-orange"
                            sub-title="2,356"
                            icon="ni ni-chart-pie-35">

                    <template slot="footer">
                        <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                        <span class="text-nowrap">Since last month</span>
                    </template>
                </stats-card>
                -->
                <!-- STEP 3 -->
                <section v-if="step === 3">
                  <form class="needs-validation" id="formCustomerData"
                          @submit.prevent="sendFormCustomer"
                          @keyup.enter="eventoEnter($event)"
                          @keydown.enter="eventoEnter($event)"
                  >
                      <base-input type="hidden" v-model="planElegido" ></base-input>
                      <h3 class="mb-3">Datos de la Materia Asegurada</h3>
                      <div class="form-row" v-for="(item,index) in atributos_materia" :key="index">
                        <div class="col-md-12" v-if="item.regex">
                          <base-input v-model="item.value" 
                                      :label="item.nombre"
                                      :name="item.nombre"
                                      :placeholder="item.nombre == 'fecha expedicion' ? 'dd/mm/aaaa' : 'Ingrese '+item.nombre"
                                      :error="getError(item.nombre)"
                                      v-validate="{ required: true, regex: new RegExp(item.regex) }"
                                      
                                      :disabled="!!$store.state.loadingStack"
                          ></base-input>
                          <button :disabled="!!$store.state.loadingStack" @click="consultarDatosClientePorNumeroEncargo" v-if="item.nombre == 'Número de Encargo' && customer.pais == 'Perú'"  type="button" class="btn btn-primary btn-sm mb-3">Consultar datos</button>
                        </div>
                        <div class="col-md-12" v-else>
                          <base-input v-model="item.value" 
                                      :label="item.nombre"
                                      :name="item.nombre"
                                      :error="getError(item.nombre)"
                                      v-validate="'required'"
                                      :disabled="!!$store.state.loadingStack"
                          ></base-input>
                          <button :disabled="!!$store.state.loadingStack" @click="consultarDatosClientePorNumeroEncargo" v-if="item.nombre == 'Número de Encargo' && customer.pais == 'Perú'"  type="button" class="btn btn-primary btn-sm mb-3">Consultar datos</button>
                        </div>
                      </div>
                      <h3 >{{title_customer}}</h3>
                      <!--
                      <div class="form-row">
                        <div class="col-md-6">
                          <base-radio name="nuevo" class="mb-3 mt-3" v-model="cliente">
                              Completar con cliente nuevo
                          </base-radio>
                        </div>
                        <div class="col-md-6">
                          <base-radio name="existente" class="mb-3 mt-3" v-model="cliente">
                              Completar con cliente existente
                          </base-radio>
                        </div>
                      </div>
                      -->
                      <div class="form-row">
                        <div class="col-md-12">
                          <base-input label="País:"
                                      :name="'Pais'"
                                      :error="getError('Pais')"
                                      v-validate="'required'"
                                      v-model="customer.pais"
                          >
                              <el-select   v-model="customer.pais" filterable disabled
                                          placeholder="Seleccione pais:"
                                          
                                          >
                                  <el-option v-for="option in paisesList"
                                              :key="option"
                                              :label="option"
                                              :value="option">
                                  </el-option>
                              </el-select>
                          </base-input>
                        </div>
                      </div>
                      <div class="form-row">
                          <div class="col-md-12" v-show="cliente == 'nuevo'">
                              <!--
                              <base-input v-if="customer.pais == 'Chile'" :label="label_dni" alternative  placeholder="Ingresa un rut">
                                <input  class="form-control" 
                                        v-model="rutql" 
                                        v-rut 
                                        placeholder="Ingresa un rut"
                                        
                                >
                              </base-input>
                              <base-input :label="label_dni"
                                          placeholder="Ingresa un dni"
                                          v-model="rutql"
                                          :name="'dni'"
                                          :error="getError('dni')"
                                          v-validate="'dniperu'"
                                          v-if="customer.pais == 'Perú'"
                              >
                              </base-input>
                              -->
                              <base-input 
                                :label="customer.pais == 'Chile' ? 'RUT '+rut_additional_info : (customer.pais == 'Ecuador' ? 'Cédula o RUC' : 'DNI')"
                                v-model="rutql"
                                :name="customer.pais == 'Chile' ? 'RUT' : (customer.pais == 'Ecuador' ? 'Cédula/Pasaporte o RUC' : 'DNI')"
                                :error="getError(customer.pais == 'Chile' ? 'RUT' : (customer.pais == 'Ecuador' ? 'Cédula/Pasaporte o RUC' : 'DNI'))"
                                v-validate="reglaValidacionDni"
                              >
                                <vue-simple-suggest
                                  v-model="rutql"
                                  :list="example"
                                  :placeholder="placeholderRut"
                                  :filter-by-query="true"
                                  @select="searchCustomer"
                                  display-attribute="name"
                                  ref="sugeridor"
                                  >
                                    <div slot="suggestion-item" slot-scope="scope">
                                      <span v-html="boldenSuggestion(scope)"></span>
                                    </div>
                                </vue-simple-suggest>
                              </base-input>
                              <button :disabled="!!$store.state.loadingStack" @click="consultarDatosClientePorDni" v-if="sponsor.toLowerCase().search('gmo') != -1 && customer.pais == 'Perú'"  type="button" class="btn btn-primary btn-sm mb-3">Consultar datos</button>
                          </div>
                          <div class="col-md-12" v-show="cliente == 'existente'"> 
                            <base-input v-model="customer.rut_autocomplete" :label="labelDni" alternative  placeholder="Ingresa un rut">
                                <autocomplete
                                  :source="example"
                                  input-class="form-control"
                                  @input="searchCustomer"
                                  v-model="customer.rut_autocomplete"
                                  @clear="clearSearchCustomer"
                                  placeholder="Ingresa un rut con puntos y guión"
                                >
                                </autocomplete>
                            </base-input>
                          </div>
                      </div>
                      <div class="form-row" v-if="customer.pais == 'Colombia' && sponsor == 'GMO COLOMBIA'">
                        <div class="col-md-12">
                          <base-input  
                                      v-model="customer.expedicion_dni" label="Fecha de expedicion DNI:" 
                                      :name="'Fecha de expedicion DNI'"
                                      :error="getError('Fecha de expedicion DNI')"
                                      v-validate="'required'"
                                      addon-left-icon="ni ni-calendar-grid-58"
                          >
                            <flat-picker slot-scope="{focus, blur}"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="config"
                                        placeholder="Ingrese Fecha de expedicion DNI XX-XX-XXXX"
                                        class="form-control datepicker"
                                         :disabled="cliente == 'existente' && clienteEncontrado == undefined" 
                                        v-model="customer.expedicion_dni">
                            </flat-picker>
                          </base-input>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col-md-12">
                          <base-input :disabled="cliente == 'existente' && clienteEncontrado == undefined" 
                                      v-model="customer.nombre" 
                                      v-bind:label="name_field_customer"
                                      placeholder="Ingresa el nombre del cliente"
                                      :name="'Nombre del cliente'"
                                      :error="getError('Nombre del cliente')"
                                      v-validate="'required'"
                          >
                          </base-input>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col-md-6" v-show="!data_is_company">
                          <base-input :disabled="cliente == 'existente' && clienteEncontrado == undefined" 
                                      v-model="customer.paterno" label="Apellido paterno:" 
                                      placeholder="Ingrese apellido paterno"
                                      :name="'Apellido Paterno'"
                                      :error="getError('Apellido Paterno')"
                                      v-validate="'required'"
                                      >
                          </base-input>
                        </div>
                        <div class="col-md-6" v-show="!data_is_company">
                          <base-input :disabled="cliente == 'existente' && clienteEncontrado == undefined" 
                                      v-model="customer.materno" 
                                      label="Apellido materno:" 
                                      placeholder="Ingrese apellido materno"
                                      :name="'Apellido Materno'"
                                      :error="getError('Apellido Materno')"
                                      v-validate="'required'"
                          >
                          </base-input>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col-md-12" v-show="!data_is_company && !data_is_disabled">
                          <base-input addon-left-icon="ni ni-calendar-grid-58" label="Fecha de nacimiento:"
                                      name="Fecha de nacimiento"
                                      :error="getError('Fecha de nacimiento')"
                                      v-validate="'required'"
                                      v-model="customer.nacimiento"
                          >
                            <flat-picker slot-scope="{focus, blur}"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="config"
                                        placeholder="Ingrese fecha de nacimiento XX-XX-XXXX"
                                        class="form-control datepicker"
                                         :disabled="cliente == 'existente' && clienteEncontrado == undefined" 
                                        v-model="customer.nacimiento">
                            </flat-picker>
                          </base-input>
                        </div>
                      </div>
                      <div class="form-row">
                        <!--
                        <div class="col-md-6">
                          <base-input :disabled="cliente == 'existente' && clienteEncontrado == undefined"  
                                      v-model="customer.telefono_movil" 
                                      label="Teléfono móvil:" 
                                      placeholder="Ingrese teléfono móvil"
                                      :name="'Teléfono movil'"
                                      :error="getError('Teléfono movil')"
                                      v-validate="'required'"

                          >
                          </base-input>
                        </div>
                        -->
                        
                        <div class="col-md-6" v-if="customer.pais == 'Chile'" >
                          <base-input :disabled="cliente == 'existente' && clienteEncontrado == undefined"  
                                      v-model="customer.telefono_movil" 
                                      label="Teléfono móvil:" 
                                      placeholder="Ingrese teléfono móvil. Formato 56912345678"
                                      :name="'Teléfono movil'"
                                      :error="getError('Teléfono movil')"
                                      v-validate="{ required: true }"

                          >
                          </base-input>
                        </div>
                        <div class="col-md-6" v-if="customer.pais != 'Chile'">
                          <base-input :disabled="cliente == 'existente' && clienteEncontrado == undefined"  
                                      v-model="customer.telefono_movil" 
                                      label="Teléfono móvil:" 
                                      placeholder="Ingrese teléfono móvil"
                                      :name="'Teléfono movil'"
                                      :error="getError('Teléfono movil')"
                                      v-validate="'required'"

                          >
                          </base-input>
                        </div>
                        
                        <div class="col-md-6" v-show="!data_is_disabled">
                          <base-input :disabled="cliente == 'existente' && clienteEncontrado == undefined"  
                                      v-model="customer.telefono_fijo" 
                                      label="Teléfono fijo:" 
                                      placeholder="Ingrese teléfono fijo (opcional)">
                          </base-input>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col-md-12" v-show="!data_is_disabled">
                          <base-input
                            label="Dirección:" 
                            v-model="customer.direccion"
                            :name="'Dirección'"
                            :error="getError('Dirección')"
                            v-validate="'required'"
                          >
                            <!--
                            <gmap-autocomplete 
                              class="form-control"
                              placeholder="Ingrese una dirección"
                              @place_changed="setPlace"
                              ref="gautocomplete"
                              @input="autocompleteUser($event)" 
                            >
                            </gmap-autocomplete>
                            -->
                          </base-input>
                              
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col-md-6" v-show="!data_is_disabled">
                          <base-input
                            label="Numero de Piso"
                            v-model="customer.numero_piso"
                            type="number"
                          >
                          </base-input>
                        </div>
                        <div class="col-md-6" v-show="!data_is_disabled">
                          <base-input
                            label="Numero de Depto/Oficina"
                            v-model="customer.depto_oficina"
                            placeholder="Ejemplo: Depto 0802"
                          >
                          </base-input>
                        </div>
                      </div>
                      <div class="form-row" v-show="customer.pais == 'Chile' || customer.pais == 'Ecuador'">
                        <div class="col-md-12" v-if="customer.pais == 'Chile'" v-show="!data_is_disabled">
                          <base-input label="Región:"
                                      :name="'Región'"
                                      :error="getError('Región')"
                                      v-validate="customer.pais == 'Chile' ? 'required' : ''"
                                      v-model="customer.region"
                          >
                              <el-select :disabled="cliente == 'existente' && clienteEncontrado == undefined"  @change="updateComunas" v-model="customer.region" filterable
                                          placeholder="Seleccione región:"
                                          
                                          >
                                  <el-option v-for="option in dataRegiones"
                                              :key="option.region"
                                              :label="option.region"
                                              :value="option.region">
                                  </el-option>
                              </el-select>
                          </base-input>
                        </div>
                        <div class="col-md-12" v-if="customer.pais == 'Ecuador'" v-show="!data_is_disabled">
                          <base-input :disabled="cliente == 'existente' && clienteEncontrado == undefined"  
                                      v-model="customer.region" 
                                      label="Provincia:" 
                                      placeholder="Ingrese provincia"
                                      :name="'Provincia'"
                                      :error="getError('Provincia')"
                                      v-validate="customer.pais == 'Ecuador' ? 'required' : ''"
                                      >
                          </base-input>
                        </div>
                      </div>
                      <div class="form-row" v-show="customer.pais == 'Chile'">
                        <div class="col-md-12" v-show="!data_is_disabled">
                          <base-input label="Comuna:"
                                      :name="'Comuna'"
                                      :error="getError('Comuna')"
                                      v-validate="customer.pais == 'Chile' ? 'required' : ''"
                                      v-model="customer.comuna"
                          >
                              <el-select  :disabled="!customer.region" v-model="customer.comuna" filterable
                                          placeholder="Seleccione comuna:"
                                          
                                          >
                                  <el-option v-for="option in comunasList"
                                              :key="option"
                                              :label="option"
                                              :value="option">
                                  </el-option>
                              </el-select>
                          </base-input>
                        </div>
                      </div>
                      <div class="form-row" v-show="customer.pais == 'Chile' || customer.pais == 'Ecuador'">
                        <div class="col-md-12" v-show="!data_is_disabled">
                          <base-input :disabled="cliente == 'existente' && clienteEncontrado == undefined"  
                                      v-model="customer.ciudad" 
                                      label="Ciudad:" 
                                      placeholder="Ingrese ciudad"
                                      :name="'Ciudad'"
                                      :error="getError('Ciudad')"
                                      v-validate="customer.pais == 'Chile' || customer.pais == 'Ecuador' ? 'required' : ''"
                                      >
                          </base-input>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col-md-12">
                          <base-input :disabled="cliente == 'existente' && clienteEncontrado == undefined"  
                                      v-model="customer.email" 
                                      type="email"
                                      label="Email:" 
                                      placeholder="Ingrese email"
                                      :name="'Email'"
                                      :error="getError('Email')"
                                      v-validate="'required|email'"
                                      >
                          </base-input>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col-md-12">
                          <base-input
                            label="Actualizar Datos Cliente"
                            v-model="checkboxActualizar"
                            >
                            <base-switch onText="Si" offText="No" v-model="checkboxActualizar"></base-switch>
                          </base-input>
                        </div>
                      </div>
                      <div class="form-row">
                          <base-button icon type="primary" nativeType="submit" form="formCustomerData" >
                              <span class="btn-inner--text">Enviar</span>
                              <span class="btn-inner--icon"><i class="ni ni-bold-right"></i></span>
                          </base-button>
                      </div>
                  </form>
                </section> 
            
            

          </card>
        </div>
      </div>
      <!-- End Formulario-->

      

      
    </div>
    <modal :show.sync="showSelectEncargos" size="sm">
      <h6 slot="header" class="modal-title">Selecciona un encargo</h6>
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Encargo"
                      v-model="encargosSelect"
                      name="Encargo"
          >
              <el-select  v-model="encargosSelect" filterable
                          placeholder="Seleccione encargo">
                  <el-option v-for="option in encargosList"
                              :key="option"
                              :label="option"
                              :value="option">
                  </el-option>
              </el-select>
          </base-input>
        </div>
      </div>
      <template slot="footer">
        <base-button type="primary" nativeType="button" @click="listenAcceptSelectEncargos">Aceptar</base-button>
      </template>
    </modal>
  </div>
</template>
<script>
  import { FadeTransition } from 'vue2-transitions';
  import { VStepper } from 'vue-stepper-component';
  import VueNumeric from 'vue-numeric';
  // Components
  import BaseProgress from '@/components/BaseProgress';
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import StatsCard from '@/components/Cards/StatsCard';

  // Lists
  import ActivityFeed from '@/views/Dashboard/ActivityFeed';
  import TaskList from '@/views/Dashboard/TaskList';
  import UserList from '@/views/Dashboard/UserList';
  import ProgressTrackList from '@/views/Dashboard/ProgressTrackList';

  // Tables
  import LightTable from '@/views/Dashboard/LightTable';
  import SocialTrafficTable from '@/views/Dashboard/SocialTrafficTable';
  import PageVisitsTable from '@/views/Dashboard/PageVisitsTable';

  import { Select, Option } from 'element-ui';
  import isotope from 'vueisotope'
  
  import swal from 'sweetalert2';

  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  
  import Autocomplete from 'vuejs-auto-complete';

  import VueSimpleSuggest from 'vue-simple-suggest'
  import 'vue-simple-suggest/dist/styles.css' // Using a css-loader
  const Spanish = require("flatpickr/dist/l10n/es.js").default.es;
  //import {GmapAutocomplete} from 'vue2-google-maps/src/components/autocomplete'


  export default {
    components: {
      Autocomplete,
      ActivityFeed,
      BaseProgress,
      RouteBreadCrumb,
      StatsCard,
      TaskList,
      PageVisitsTable,
      SocialTrafficTable,
      LightTable,
      UserList,
      ProgressTrackList,
      FadeTransition,
      VStepper,
      [Select.name]: Select,
      [Option.name]: Option,
      VueNumeric,
      isotope,
      flatPicker,
      VueSimpleSuggest,
      
    },
    data() {
      return {
        reglaValidacionDni: undefined,
        config: { dateFormat: 'd-m-Y', allowInput: true, locale: Spanish },
        steps: 3,
        step: 1,
        selectCategorias: [],
        selectSubCategorias: [],
        categoria: {
            value: undefined,
            label: ''
        },
        subCategoria: {
            value: undefined,
            label: '',
        },
        monto_venta: '',
        lista_planes: [],
        selectFiltroOrdenar: [ 
          {label: 'Nombre', value: 'name'}, 
          {label: 'Valor de plan', value: 'valor'},
          {label: 'Compañía de seguros', value: 'company'}
        ],
        filtroOrdenar: '',
        opcionesIsotope: {
          layoutMode: 'fitRows',
          getSortData: {
            id: "id",
            valor: function(itemElem){
              return itemElem.valor;
            },
            name: function(itemElem){
              return itemElem.name.toLowerCase();     
            },
            company: function(itemElem){
              return itemElem.company.name.toLowerCase();
            }
          }
        },
        attrs: [],
        attrFields: [],
        sponsor: "",
        customer: {
          rut: '',
          rut_autocomplete: '',
          nombre: '',
          paterno: '',
          materno: '',
          nacimiento: '',
          telefono_movil: '',
          telefono_fijo: '',
          direccion: '',
          region: '',
          comuna: '',
          ciudad: '',
          provincia: undefined,
          email: '',
          pais: 'Colombia',
          numero_piso: undefined,
          depto_oficina: undefined,
          expedicion_dni: '',
        },
        dataRegiones: [],
        comunasList: [],
        paisesList: [
          "Chile",
          'Perú' ,
          "Colombia",
          "Ecuador",
          "Argentina"
        ],
        example: [
          {id: 1, name: '19.150.812-2'},
          {id: 2, name: '5.951.847-k'}
        ],
        cliente: 'nuevo',
        clienteEncontrado: undefined,
        atributos_materia: [],
        planElegido: undefined,
        rutql: '',
        checkboxActualizar: false,
        cargando: false,
        regexTelefonosMovilesChile: "^(\\+?56)?(\\s?)(0?9)(\\s?)[9876543]\\d{7}$",
        response_gmo: {},
        encargosList: [],
        encargosSelect: undefined,
        showSelectEncargos: false,

        // Empresa
        title_customer: 'Datos del contratante',
        name_field_customer: 'Nombre:',
        data_is_company : false,
        data_is_disabled : false,
        rut_additional_info : '',
      };
    },
    methods: {
      eventoEnter(evt){
          console.log('metodo EventoEnter: ');
          //console.log(evt);
          evt.stopPropagation();
      },
      setPlace(gobj){
        console.log(gobj);
        this.customer.pais = gobj.address_components.find( e => e.types.find( r => r == "country" )  ).long_name;
        this.customer.direccion = this.$refs.gautocomplete.$refs.input.value;
        this.customer.region = gobj.address_components.find( e => e.types.find( r => r == "administrative_area_level_1" )  ).long_name;
        switch( this.customer.pais ){
          case 'Chile':
            this.customer.ciudad = gobj.address_components.find( e => e.types.find( r => r == "administrative_area_level_3" )  ).long_name;
            this.customer.comuna = gobj.address_components.find( e => e.types.find( r => r == "administrative_area_level_3" )  ).long_name;
            break;
          case 'Perú':
            this.customer.ciudad = gobj.address_components.find( e => e.types.find( r => r == "locality" )  ).long_name;
            this.customer.comuna = gobj.address_components.find( e => e.types.find( r => r == "locality" )  ).long_name;
            break;
          case 'Colombia':
            this.customer.ciudad = (gobj.address_components.find( e => e.types.find( r => r == "administrative_area_level_2" )  ) ? gobj.address_components.find( e => e.types.find( r => r == "administrative_area_level_2" )  ).long_name : 'no encontrado') ;
            this.customer.comuna = (gobj.address_components.find( e => e.types.find( r => r == "locality" )  ) ? gobj.address_components.find( e => e.types.find( r => r == "locality" )  ).long_name : 'no encontrado') ;
            break;
          case 'Ecuador':
            this.customer.ciudad = (gobj.address_components.find( e => e.types.find( r => r == "administrative_area_level_2" )  ) ? gobj.address_components.find( e => e.types.find( r => r == "administrative_area_level_2" )  ).long_name : 'no encontrado') ;
            this.customer.comuna = (gobj.address_components.find( e => e.types.find( r => r == "locality" )  ) ? gobj.address_components.find( e => e.types.find( r => r == "locality" )  ).long_name : 'no encontrado') ;
            break;
        }
        
        if( this.customer.pais == 'Chile') this.updateComunas();
      },
      async autocompleteUser(e, value, index) {
        this.customer.direccion = e.target.value;
        e.stopPropagation();
      },
      consultarDatosClientePorNumeroEncargo()
      {
        let value = this.atributos_materia.find(item => item.nombre == 'Número de Encargo') ? this.atributos_materia.find(item => item.nombre == 'Número de Encargo').value : '';
        console.log('value', value);
        if(value.length >= 1 && this.customer.pais == 'Perú'){
          var vm = this;
          this.axios({
            url: 'api/ventas/utils/gmo/data_by_nro_encargo',
            method: 'POST',
            data: {
              nro_encargo: value
            }
          }).then(response => {
            vm.rutql = response.data.dni;
            vm.customer.nombre = response.data.nombre;
            vm.customer.paterno = response.data.apellido_paterno;
            vm.customer.materno = response.data.apellido_materno;
            vm.customer.nacimiento = response.data.fecha_nacimiento;
            vm.customer.telefono_movil = response.data.telefono;
            vm.customer.direccion = response.data.direccion;
            vm.customer.region = response.data.region;
            vm.customer.comuna = response.data.ciudad;
            vm.customer.ciudad = response.data.ciudad;
            vm.customer.provincia = response.data.provincia;
            vm.customer.email = response.data.email;
            vm.customer.numero_piso = "";
            vm.customer.depto_oficina = "";
          }).catch( error => {

            if( error.response && error.response.data.errors !== undefined && error.response.data.errors.mensaje !== undefined ){ 
                Object.keys(error.response.data.errors).forEach( key =>{
                  vm.$notify({
                    message: error.response.data.errors[key][0],
                    timeout: 5000,
                    icon: 'ni ni-bell-55',
                    type: 'warning'
                  });
                });
            }
            else{
              vm.$notify({
                  message: 'No se encontraron resultados',
                  timeout: 5000,
                  icon: 'ni ni-bell-55',
                  type: 'default'
              });
            }

            
          });
          
        }
      },
      consultarDatosClientePorDni()
      {
        if( this.customer.pais == 'Perú'){
          var vm = this;
          this.axios({
            url: 'api/ventas/utils/gmo/data_by_dni',
            method: 'POST',
            data: {
              dni: this.rutql
            }
          }).then(response => {
            if(response.data.encargos.length){
              vm.response_gmo = response.data;
              vm.encargosList = response.data.encargos;
              vm.encargosSelect = undefined;
              vm.showSelectEncargos = true;
            }
          }).catch(() => {
            vm.$notify({
                message: 'No se encontraron resultados',
                timeout: 5000,
                icon: 'ni ni-bell-55',
                type: 'default'
            });
          });
        }
      },
      listenAcceptSelectEncargos(){
        if(!!this.encargosSelect && !!this.response_gmo){
            this.rutql = this.response_gmo.dni;
            this.customer.nombre = this.response_gmo.nombre;
            this.customer.paterno = this.response_gmo.apellido_paterno;
            this.customer.materno = this.response_gmo.apellido_materno;
            this.customer.nacimiento = this.response_gmo.fecha_nacimiento;
            this.customer.telefono_movil = this.response_gmo.telefono;
            this.customer.direccion = this.response_gmo.direccion;
            this.customer.region = this.response_gmo.region;
            this.customer.comuna = this.response_gmo.ciudad;
            this.customer.ciudad = this.response_gmo.ciudad;
            this.customer.provincia = this.response_gmo.provincia;
            this.customer.email = this.response_gmo.email;
            this.customer.numero_piso = "";
            this.customer.depto_oficina = "";
            if(this.atributos_materia.find(item => item.nombre == 'Número de Encargo')){
              this.atributos_materia.find(item => item.nombre == 'Número de Encargo').value = this.encargosSelect;
            }
            
            this.showSelectEncargos = false;
        }
      },
      sendFormCustomer(){
        console.log(this.$refs.gautocomplete);
        var vm = this;
        this.firstFormSubmit().then( response => {
          console.log('retorno promesa de validacion', response);
          if( response ){
            if( vm.cliente == 'nuevo' ){
              if( vm.customer.rut == '' || vm.customer.rut == undefined || !vm.customer.rut)
              {
                return vm.$notify({ message: 'Debes completar el campo R.U.T',
                  timeout: 5000,
                  icon: 'ni ni-bell-55',
                  type: 'danger'
                });
              }
            }
            if( vm.cliente == 'existente'){
              if( vm.customer.rut_autocomplete == '' || vm.customer.rut_autocomplete == undefined || !vm.customer.rut_autocomplete)
              {
                return vm.$notify({ message: 'Debes completar el campo R.U.T',
                  timeout: 5000,
                  icon: 'ni ni-bell-55',
                  type: 'danger'
                });
              }
            }
            if( vm.planElegido == undefined || !vm.planElegido || vm.planElegido == ''){
                return vm.$notify({ message: 'Debiste haber seleccionado un plan',
                  timeout: 5000,
                  icon: 'ni ni-bell-55',
                  type: 'danger'
                });
            }
            if( vm.$moment().diff(vm.$moment(vm.customer.nacimiento, 'DD-MM-YYYY').format('YYYY-MM-DD'), 'years') < 18.0 ){
              return vm.$notify({ message: 'El cliente debe ser mayor de edad',
                  timeout: 5000,
                  icon: 'ni ni-bell-55',
                  type: 'danger'
                });
            }
            vm.axios({
              method: 'POST',
              url: 'api/store_new_sale',
              data: {
                
                rut: vm.cliente == 'nuevo' ? vm.customer.rut : vm.customer.rut_autocomplete,
                expedicion_dni: vm.customer.expedicion_dni,
                nombre: vm.customer.nombre,
                apellido_paterno: vm.customer.paterno,
                apellido_materno: vm.customer.materno,
                nacimiento: vm.customer.nacimiento,
                telefono_movil: vm.customer.telefono_movil,
                telefono_fijo: vm.customer.telefono_fijo,
                direccion: vm.customer.direccion,
                region: vm.customer.region || 'no encontrado',
                comuna: vm.customer.comuna || 'no encontrado',
                ciudad: vm.customer.ciudad || 'no encontrado',
                email:  vm.customer.email,
                pais: vm.customer.pais,
                subcategoria: vm.subCategoria.value,
                attrs: vm.attrs,
                attrFields: vm.attrFields,
                plan: vm.planElegido,
                attrsMateria: vm.atributos_materia,
                tipo: vm.cliente,
                actualizar: vm.checkboxActualizar ? 'si' : 'no',
                numero_piso: vm.customer.numero_piso,
                depto_oficina: vm.customer.depto_oficina,
              }
            })
            .then( response => {
              vm.$notify({ message: 'Plan agregado al carro exitosamente!',
                  timeout: 5000,
                  icon: 'ni ni-bell-55',
                  type: 'success'
                });
              vm.$router.push({name: 'Carro'});
            })
            .catch( error => {
              console.log(error);
              console.log(error.response.data);
              if( error.response ){
                if( error.response.data){
                  Object.keys(error.response.data.errors).forEach( key =>{
                    
                    vm.$notify({
                      message: error.response.data.errors[key][0],
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'warning'
                    });
                  });
                }
              }
            })
            ;
          } else {
            //if( !vm.customer.direccion || !vm.customer.pais || !vm.customer.ciudad || !vm.customer.comuna ) vm.$notify({ type: 'warning', message: 'La direccion ingresada no es válida, por favor intente con otra.' });
            vm.$notify({ message: 'Hay errores en los datos de ingreso. Favor revisar arriba.',
              timeout: 5000,
              icon: 'ni ni-bell-55',
              type: 'danger'
            });
          }
        })
      },
      clearSearchCustomer(){
        console.log('clean');
        this.clienteEncontrado = undefined;
        
          this.customer.rut_autocomplete = '',
          vm.customer.nombre = '';
          vm.customer.paterno = '';
          vm.customer.materno = '';
          vm.customer.nacimiento = '';
          vm.customer.telefono_movil = '';
          vm.customer.telefono_fijo = '';
          vm.customer.direccion = '';
          vm.customer.region = '';
          vm.customer.comuna = '';
          vm.customer.ciudad = '';
          vm.customer.email = '';
          vm.customer.numero_piso = undefined;
          vm.customer.depto_oficina = undefined;
      },
      searchCustomer(){
        var vm = this;
        this.axios({
          url: 'api/search_customer_data?search='+this.$refs.sugeridor.selected.id,
          method: 'GET',
        }).then( response => {
          vm.clienteEncontrado = response.data;
          
          vm.customer.nombre = response.data.nombre;
          vm.customer.paterno = response.data.paterno;
          vm.customer.materno = response.data.materno;
          vm.customer.nacimiento = response.data.nacimiento;
          vm.customer.telefono_movil = response.data.telefono_movil;
          vm.customer.telefono_fijo = response.data.telefono_fijo;
          vm.customer.direccion = response.data.direccion;
          console.log( vm.$refs.gautocomplete);
          vm.$refs.gautocomplete.$refs.input.value = response.data.direccion;
          vm.customer.region = response.data.region;
          vm.customer.comuna = response.data.comuna;
          vm.customer.ciudad = response.data.ciudad;
          vm.customer.email = response.data.email;
          vm.customer.numero_piso = response.data.numero_piso ? response.data.numero_piso : undefined;
          vm.customer.depto_oficina = response.data.depto_oficina ? response.data.depto_oficina : undefined;
          vm.updateComunas();
        })
        .catch( error => {
          console.log(error);
        })
        ;
      },
      updateComunas(){
        console.log('wea');
        if( this.dataRegiones.find( elem => elem.region == this.customer.region )){
          this.comunasList = this.dataRegiones.find( elem => elem.region == this.customer.region ).comunas;
        }
        
      },
      initBigChart(index) {
        let chartData = {
          datasets: [
            {
              label: 'Performance',
              data: this.bigLineChart.allData[index]
            }
          ],
          labels: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        };
        this.bigLineChart.chartData = chartData;
        this.bigLineChart.activeIndex = index;
      },
      finishStepOne(){
        if( !this.subCategoria.value || !this.categoria.value ) return;
        var vm = this;
        this.axios({
          url: 'api/found_plans_new_purchase',
          method: 'POST',
          data: {
            category: this.categoria.value,
            subcategory: this.subCategoria.value,
            attrs: this.attrs,
            attrFields: this.attrFields
          }
        }).then( response => {
          if(response.data.length) vm.$refs.stepper.next();
          /**
           * Llenar la grilla de planes
           */
          if( response.data.length < 1 ){
            vm.$notify({
              message: 'No se encontró ningun plan según los parametros ingresados',
              timeout: 5000,
              icon: 'ni ni-bell-55',
              type: 'danger'
            });
          }
          vm.lista_planes = response.data;
          response.data.forEach( e => { e.materia_asegurada.atributos.forEach( m => { if(m.regex) { console.log( new RegExp(m.regex), m.regex ) } } ) });

        }).catch( error => {
            vm.$notify({
              message: 'Ocurrió un error. Favor comunicarse con soporte técnico.',
              timeout: 5000,
              icon: 'ni ni-bell-55',
              type: 'danger'
            });
        });
      },
      updateSubCategorias()
      {
          this.cargando = true;
          var vm = this;
          this.axios({
              url: 'api/get_sub_categorias_list',
              method: 'POST',
              data: { category: vm.categoria.value }
          }).then( response => {
              vm.cargando = false;
              vm.selectSubCategorias = response.data;
          }).catch( error => {
              console.log(error);
              vm.cargando = false;
          });
      },
      toThirdStep(plan)
      {
        console.log(plan);
        var vm = this;
        swal({
          title: `Plan elegido: ${plan.name}, estás seguro(a) de continuar?`,
          //text: 'Si',
          buttonsStyling: false,
          confirmButtonText: 'Si',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonClass: 'btn btn-info btn-fill'
        })
        .then( function(result) {
          if(result.hasOwnProperty('value')){
            vm.atributos_materia = plan.materia_asegurada.atributos.filter( e => e.momento == 'venta');
            vm.sponsor = plan.sponsor;
            vm.planElegido = plan.id;
            vm.customer.pais = plan.pais;
            switch( plan.pais ){
              case 'Chile':
                vm.reglaValidacionDni = 'required|dnichile|max:20';
                break;
              case 'Perú':
                if(vm.sponsor == 'GMO Perú'){
                  vm.reglaValidacionDni = 'required|dniperu2|max:20';
                }else{
                  vm.reglaValidacionDni = 'required|dniperu|max:20';
                }
                break;
              case 'Colombia':
                vm.reglaValidacionDni = 'required|dnicolombia';
                break;
              case 'Ecuador':
                vm.reglaValidacionDni = 'required|dniecuador';
                break;
              case 'Costa Rica':
              vm.reglaValidacionDni = 'required|dnicostarica';
              break;
            }

            if(vm.sponsor == 'Servicio GMO Chile' || vm.sponsor == 'Servicio OPV Plus' || vm.sponsor == 'Servicio Mirada Protegida' || vm.sponsor == 'Servicio Ray Ban'){
              vm.rut_additional_info = ' BOLETA (incluye menor de edad)';
            }

            

            switch( plan.company.id){
                case 21:
                  vm.title_customer = 'Datos Empresa';
                  vm.name_field_customer = 'Nombre de la Empresa:';
                  vm.data_is_company = true;
                  vm.customer.paterno = '-';
                  vm.customer.materno = '-';
                  vm.customer.nacimiento = '01-01-1900';
                  break;
            }

            switch( plan.company.id){
                case 21:
                  vm.title_customer = 'Datos Empresa';
                  vm.name_field_customer = 'Nombre de la Empresa:';
                  vm.data_is_company = true;
                  vm.customer.paterno = '-';
                  vm.customer.materno = '-';
                  vm.customer.nacimiento = '01-01-1900';
                  break;
                case 22:
                  vm.data_is_disabled = true;
                  vm.customer.nacimiento = '01-01-1900';
                  vm.customer.telefono_fijo = '56959237962';
                  vm.customer.direccion = 'Avenida Tajamar 481';
                  vm.customer.numero_piso = '20';
                  vm.customer.depto_oficina = 'Oficina 2004';
                  vm.customer.region = 'Región Metropolitana';
                  vm.customer.comuna = 'Las Condes';
                  vm.customer.ciudad = 'Santiago';
                  
                  break;
                case 24:
                  vm.data_is_disabled = true;
                  vm.customer.nacimiento = '01-01-1900';
                  vm.customer.telefono_fijo = '56959237962';
                  vm.customer.direccion = 'Avenida Tajamar 481';
                  vm.customer.numero_piso = '20';
                  vm.customer.depto_oficina = 'Oficina 2004';
                  vm.customer.region = 'Región Metropolitana';
                  vm.customer.comuna = 'Las Condes';
                  vm.customer.ciudad = 'Santiago';
                  
                  break;

                  case 23:
                  vm.data_is_disabled = true;
                  vm.customer.nacimiento = '01-01-1900';
                  vm.customer.telefono_fijo = '56959237962';
                  vm.customer.direccion = 'Avenida Tajamar 481';
                  vm.customer.numero_piso = '20';
                  vm.customer.depto_oficina = 'Oficina 2004';
                  vm.customer.region = 'Región Metropolitana';
                  vm.customer.comuna = 'Las Condes';
                  vm.customer.ciudad = 'Santiago';
                  
                  break;

                  case 25:
                  vm.data_is_disabled = true;
                  vm.customer.nacimiento = '01-01-1900';
                  vm.customer.telefono_fijo = '56959237962';
                  vm.customer.direccion = 'Avenida Tajamar 481';
                  vm.customer.numero_piso = '20';
                  vm.customer.depto_oficina = 'Oficina 2004';
                  vm.customer.region = 'Región Metropolitana';
                  vm.customer.comuna = 'Las Condes';
                  vm.customer.ciudad = 'Santiago';

                  case 26:
                  vm.data_is_disabled = true;
                  vm.customer.nacimiento = '01-01-1900';
                  vm.customer.telefono_fijo = '56959237962';
                  vm.customer.direccion = 'Avenida Tajamar 481';
                  vm.customer.numero_piso = '20';
                  vm.customer.depto_oficina = 'Oficina 2004';
                  vm.customer.region = 'Región Metropolitana';
                  vm.customer.comuna = 'Las Condes';
                  vm.customer.ciudad = 'Santiago';

                  case 44:
                  vm.data_is_disabled = true;
                  vm.customer.nacimiento = '01-01-1900';
                  vm.customer.telefono_fijo = '56959237962';
                  vm.customer.direccion = 'Avenida Tajamar 481';
                  vm.customer.numero_piso = '20';
                  vm.customer.depto_oficina = 'Oficina 2004';
                  vm.customer.region = 'Región Metropolitana';
                  vm.customer.comuna = 'Las Condes';
                  vm.customer.ciudad = 'Santiago';
                  
                  break;
            }

            vm.$refs.stepper.next();
          }
        })
        ;
      },
      updateOrderFilter()
      {
        
        if( this.filtroOrdenar != '') this.$refs.isotope.sort(this.filtroOrdenar);
        else this.$refs.isotope.sort('original-order');
        
      },
      mostrarDetalles(plan)
      {
        swal({
          title: `Detalles de plan: ${plan.name}`,
          html: plan.detalles_html,
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-info btn-fill'
        });
      },
      fetchDataAttrs()
      {
        this.cargando = true;
        if( this.subCategoria.value != undefined && this.subCategoria.value != '' ){
          var vm = this;
          this.axios({
            url: 'api/fetch_attrs_data_from_new_sale',
            method: 'POST',
            data: {id: this.subCategoria.value},
          }).then( response => {
            vm.attrs = [];
            vm.attrs = response.data;
            vm.attrFields = [];
            response.data.forEach( (elem) => {
              vm.attrFields.push('');
            });
            vm.cargando = false;
          }).catch( error => {
            console.log(error);
            vm.cargando = false;
          });
        }
      },
      getError(name){
        return this.errors.first(name)
      },
      isValid(name) {
        return this.validated && !this.errors.has(name);
      },
      async firstFormSubmit() {
        try {
          return await this.$validator.validateAll();
          //throw new Error('hno ke wea esta wea');
        } catch {
          console.log('Oh, tengo ke caputar algo');
          return false;
        }
        finally {
          
          this.validated = true;
        }
      },
      formatearRut()
      {
        let rut = this.rutql;
        var actual = rut.replace(/^0+/, "");
        if (actual != '' && actual.length > 1) {
            var sinPuntos = actual.replace(/\./g, "");
            var actualLimpio = sinPuntos.replace(/-/g, "");
            var inicio = actualLimpio.substring(0, actualLimpio.length - 1);
            var rutPuntos = "";
            var i = 0;
            var j = 1;
            for (i = inicio.length - 1; i >= 0; i--) {
                var letra = inicio.charAt(i);
                rutPuntos = letra + rutPuntos;
                if (j % 3 == 0 && j <= inicio.length - 1) {
                    rutPuntos = "." + rutPuntos;
                }
                j++;
            }
            var dv = actualLimpio.substring(actualLimpio.length - 1);
            rutPuntos = rutPuntos + "-" + dv;
        }
        this.rutql = rutPuntos;
      },
      desformatearRut()
      {
        this.rutql = this.rutql.replace(/\./g, "");
      },
      onInputChange(){
        console.log('onInputChange');
      },
      selectHandler(objeto){
        console.log('selectHandler', objeto);
      },
      boldenSuggestion(scope) {
        if (!scope) return scope;

        const { suggestion, query } = scope;

        return suggestion.name;
      }
    },
    mounted() {
      //this.initBigChart(0);
    },
    created() {
      console.log('componente creado');
        var vm = this;
        this.axios({
          url: 'api/customers_ruts_list',
          method: 'get'
        })
        .then( response => {
          vm.example = response.data.map( e => { return { id: e.id , name: e.name.replace(/\./g,"")} } );
        })
        .catch( error => {
          console.log(error);
        })
        ;
        this.axios({
            url: 'api/get_categorias_list',
            method: 'get',
        }).then( response => {
            vm.selectCategorias = response.data;
        }).catch( error => {
            console.log(error);
        });
        this.dataRegiones = require("./regiones.json");
    },
    computed: {
      firstStepReady()
      {
        let flag = true;
        this.attrFields.forEach( elem => {
          if( elem == undefined || elem == '' ) flag = false;
        });
        if( this.categoria.value == undefined || this.categoria.value == '' || this.subCategoria.value == undefined || this.subCategoria.value == '' ) flag = false;
        return flag;
      },
      labelDni(){
        switch( this.customer.pais ){
          case 'Chile':
            return 'R.U.T';
            break;
          case 'Perú':
            return 'DNI';
            break;
          case 'Colombia':
            return 'DNI';
            break;
          case 'Argentina':
            return 'DNI';
            break;
          case 'Ecuador':
            return 'DNI';
            break;
        }
      },
      paisComputado: function(){
        return this.customer.pais;
      },
      placeholderRut(){
        
        switch( this.customer.pais ){
          case 'Chile':
            return 'Formato: 12345678-9';
            break;
          case 'Perú':
            return 'Ingrese DNI';
            break;
          case 'Colombia':
            return 'Formato: 6845256666';
            break;
          case 'Ecuador':
            return 'Formato: 1706384771';
            break;
          case 'Argentina':
            return 'Formato: 12.345.678';
            break;
          default:
            return 'Ingrese DNI';
            break;
        }
      }
    },
    watch: {
      rutql:{
        handler: function(n,o){
          this.customer.rut = this.rutql;
        },
        
      },
      paisComputado: {
        handler: function (newValue, oldValue) {
          console.log('nuevo', newValue, 'old', oldValue);
          switch( newValue ){
            case 'Chile':
              this.reglaValidacionDni = 'required|dnichile';
              break;
            case 'Perú':
              if(this.sponsor){
                if(this.sponsor == 'GMO Perú'){
                  this.reglaValidacionDni = 'required|dniperu2';
                }else{
                  this.reglaValidacionDni = 'required|dniperu';
                }
              }else{
                this.reglaValidacionDni = 'required|dniperu';
              }
              
              break;
            case 'Colombia':
              this.reglaValidacionDni = 'required|dnicolombia';
              break;
            case 'Ecuador':
              this.reglaValidacionDni = 'required|dniecuador';
              break;
          }
        },
      }
      
    },
  };
</script>
<style lang="scss">

.autosuggest__results {
      font-weight: 300;
      margin: 0;
      position: absolute;
      z-index: 10000001;
      width: 100%;
      border: 1px solid #e0e0e0;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      background: white;
      padding: 0px;
      overflow: scroll;
      max-height: 200px;
    }
    
    .autosuggest__results ul {
      list-style: none;
      padding-left: 0;
      margin: 0;
    }
    

</style>
